export type StructVersionBrief = {
  hash: string
  author: { id: number; email: string }
  created_at: string
  fields: {
    data: any
    is_completed?: boolean
    is_published?: boolean
    is_archived?: boolean
  }
}

export enum AdStatus {
  INACTIVE = 'Inactive',
  PUBLISHED = 'Published',
  COMPLETED = 'Completed',
}

export const AdStructTypes = [
  'promo-dialog',
  'banner-ad',
  'page-takeover-ad',
  'sponsored-content',
  'toast-notification',
]
